import { NgModule } from '@angular/core';
import { SHARED_ZORRO_MODULES } from './shared-zorro.module';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { PipesModule } from './pipes/pipes.module';
import { ComponentsModule } from './components/components.module';
import { QuicklinkModule } from 'ngx-quicklink';
import { CardTableWrapModule } from './components/card-table-wrap/card-table-wrap.module';
import { DirectivesModule } from './directives/directives.module';
import { HoverPreloadModule } from 'ngx-hover-preload';
import { DragDropModule } from '@angular/cdk/drag-drop';
// import { SortablejsModule } from 'ngx-sortablejs';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxQRCodeModule } from 'ngx-qrcode2';
import { NzSkeletonModule } from 'ng-zorro-antd/skeleton';

const MODULES = [
  CommonModule,
  FormsModule,
  ReactiveFormsModule,
  RouterModule,
  PipesModule,
  ComponentsModule,
  QuicklinkModule,
  HoverPreloadModule,
  CardTableWrapModule,
  DirectivesModule,
  NgxEchartsModule,
  NgxQRCodeModule,
  NzSkeletonModule,
  ...SHARED_ZORRO_MODULES
];

@NgModule({
  declarations: [],
  imports: [
    DragDropModule,
    // SortablejsModule.forRoot({ animation: 150 }),
    // SortablejsModule.forRoot({ animation: 150 }),
    ...MODULES,
  ],
  exports: [
    ...MODULES
  ]
})
export class SharedModule {
}
